import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { merchantsService } from '../../../shared/api/services/merchants.service'

export const SellerNameDisplay: React.FC<{ sellerId: string }> = ({ sellerId }) => {
    const { data: merchant, isLoading } = useQuery({
        queryKey: ['merchant', sellerId],
        queryFn: () => merchantsService.getMerchantById(sellerId),
        enabled: !!sellerId,
        staleTime: 1000 * 60 * 10, // Cache for 10 minutes
    })

    if (isLoading) return <span>Loading...</span>
    if (!merchant) return <span>Seller #{sellerId?.substring(0, 8)}...</span>

    return (
        <span>{merchant.business_name || merchant.owner_name}</span>
    )
}
